import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import axios from 'axios';
import { Link } from 'react-router-dom';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TableFooter from '@mui/material/TableFooter';
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
import { fetchData, deleteData, activateData, updateData, SyncData, postData, DespatchData, ReportData } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import { Tooltip } from '@mui/material';
import ArrowForward from '@mui/icons-material/ArrowForward';
import Select from 'react-select';
import { useParams, useHistory } from 'react-router-dom';
import Modal from '@mui/material/Modal';
import { FaTimes } from 'react-icons/fa';
import Button from '@mui/material/Button';
import RefreshIcon from '@mui/icons-material/Refresh';
import * as XLSX from 'xlsx';
import CircularProgress from '@mui/material/CircularProgress';

function ClosingSummary() {
    const history = useHistory();
    const [data, setData] = useState([]);
    const [deleteItemId, setDeleteItemId] = useState(null);
    const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
    const [editedRouteSequenceNo, setEditedRouteSequenceNo] = useState(null);
    const [orderdate, setOrderdate] = useState("");
    const [editItemId, setEditItemId] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(false);
    const [formData, setFormData] = useState();
    const [tripOptions, setTripOptions] = useState([]);
    const [selectedTrip, setSelectedTrip] = useState(null);
    const [searchQuery, setSearchQuery] = useState('');
    const [tripDate, setTripDate] = useState('');
    const { isAuthenticated, companyId, userId, permissions, token, logout } = useAuth();
    const hasCreateMasterPermission = permissions.includes('Create Master');
    const hasEditMasterPermission = permissions.includes('Edit Master');
    const hasDeleteMasterPermission = permissions.includes('Delete Master');
    const [saleOrderId, setSaleOrderId] = useState(false);
    const [showTable, setShowTable] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [selectedCustomerData, setSelectedCustomerData] = useState(null);
    const [toDate, setToDate] = useState(new Date().toISOString().split('T')[0]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
        }
    }, [isAuthenticated, companyId, token, logout]);

    useEffect(() => {
        fetchTripTypes();
    }, []);

    const fetchTripTypes = async () => {
        try {
            const response = await fetchData('CustomerOrderedItemAPI', `/${companyId}`, token);
            if (response.responseCode === '1111') {
                const options = response.response_data.map(trip => ({
                    value: trip.Id,
                    label: trip.Description
                }));
                setTripOptions(options);
            }
        } catch (error) {
            console.error('Error fetching route:', error);
        }
    };


    const [filteredData, setFilteredData] = useState([]);
    const [Corderdate, setCorderdate] = useState("");
    const [orderTakenby, setOrdertakenby] = useState("");
    const [TripName, settripName] = useState("");
    const [Startkm, setStartkm] = useState("");
    const [EndKm, setEndKm] = useState("");
    const [DriverName, setDriverName] = useState("");
    const [vehicleNo, setvehicleNo] = useState("");
    const [route, setroute] = useState("");
    const [Refuleingkm, setRefuleingkm] = useState("");



    const handleTripChange = async (selectedOption) => {
        setSelectedTrip(selectedOption);
        setData([]);
        setLoading(true);

        try {
            // First API call to 'CollectionSummaryByRouteApi'
            const response1 = await fetchData(
                'CollectionSummaryByRouteApi',
                `/${companyId}/${selectedOption.value}`,
                token
            );

            if (response1.responseCode === '1111') {
                const dataArray1 = response1.response_data;
                setData(dataArray1);

                if (dataArray1.length > 0) {
                    // Set the necessary state from response data
                    setSaleOrderId(dataArray1[0].id);
                    setCorderdate(dataArray1[0].orderDate);
                    setOrdertakenby(dataArray1[0].orderTakenby);
                    setroute(dataArray1[0].routeName);
                    settripName(dataArray1[0].tripName);
                    setStartkm(dataArray1[0].StartKm);
                    setEndKm(dataArray1[0].EndKm);
                    setDriverName(dataArray1[0].DriverName);
                    setvehicleNo(dataArray1[0].VehicleNo);
                    setRefuleingkm(dataArray1[0].Refuelingkm);
                }
            } else {
                console.error('Unexpected response code in CollectionSummaryByRouteApi:', response1.responseCode);
            }

            // Second API call to 'ExpenseSummery'
            const response2 = await fetchData('ExpenseSummery', `/${companyId}/${selectedOption.value}`, token);

            if (response2.responseCode === '1111') {
                const dataArray2 = response2.response_data;
                //setFilteredData(dataArray2.filter(item => (selectedOption ? item.route === selectedOption.value : true))
                setFilteredData(dataArray2);

                console.log(response2);

                console.log(dataArray2);
            } else {
                console.error('Unexpected response code in ExpenseSummery:', response2.responseCode);
            }
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setLoading(false);
        }
    };



    const handleHistoryClick = async (saleorderid) => {
        try {
            const response = await fetchData('VehicleApi', `/${companyId}/${saleorderid}`, token);
            if (response.responseCode === '1111') {
                setSelectedCustomerData(response.response_data);
                setShowModal(true);
            }
        } catch (error) {
            console.error('Error fetching Order Items:', error);
        }
    };

    const closeModal = () => {
        setShowModal(false);
    };

    //handle search
    const handleSearch = (event) => {
        setSearchQuery(event.target.value);
    };


    const handlePrint = () => {
        const printWindow = window.open('', '_blank');
        printWindow.document.write('<html><head><title>Route Closing Summary</title></head><body>');
        printWindow.document.write('<h3 style="font-family: Times New Roman; font-size: 32px;">Route Closing Summary</h3>');

        // Add common details
        if (data.length > 0) {
            const firstRow = data[0];
            printWindow.document.write('<div style="margin-bottom: 20px;">');
            printWindow.document.write(`<p style="font-size: 18px;">`);
            printWindow.document.write(`<strong>Route:</strong> ${firstRow.routeName || ''} &nbsp; | &nbsp; `);
            printWindow.document.write(`<strong>Order Taken by:</strong> ${firstRow.orderTakenby || ''} &nbsp; | &nbsp; `);
            printWindow.document.write(`<strong>Sales Executive:</strong> ${firstRow.salesman || ''} &nbsp; | &nbsp; `);
            printWindow.document.write(`<strong>Order Date:</strong> ${firstRow.orderDate ? new Date(firstRow.orderDate).toLocaleDateString('en-GB') : ''} &nbsp; | &nbsp; `);
            printWindow.document.write(`<strong>Trip Name:</strong> ${firstRow.tripName || ''} &nbsp; | &nbsp;`);
            printWindow.document.write(`<strong>Start KM:</strong> ${firstRow.Startkm || ''} &nbsp; | &nbsp;`);
            printWindow.document.write(`<strong>End KM:</strong> ${firstRow.EndKm || ''} &nbsp; | &nbsp;`);
            printWindow.document.write(`<strong>Driver Name:</strong> ${firstRow.DriverName || ''} &nbsp; | &nbsp;`);
            printWindow.document.write(`<strong>Vehicle No:</strong> ${firstRow.VehicleNo || ''} &nbsp; | &nbsp; `);
            printWindow.document.write(`<strong>ReFueling KM:</strong> ${firstRow.Refuelingkm || ''}  `);
            printWindow.document.write(`</p>`);
            printWindow.document.write('</div>');
        }

        // Add table headers
        printWindow.document.write('<table style="border-collapse: collapse; width: 100%;">');
        printWindow.document.write('<thead style="background-color: #f3f3f3;">');
        // Start with Closing Summary Table
        printWindow.document.write(`
        <div style="width: 100%; overflow-y: auto; margin-top: 5px;">
            <table style="width: 100%; border-collapse: collapse; text-align: left;">
                <thead>
                    <tr style="background-color: #E4E0E1;">
                        <th colspan="13" style="font-weight: bold; padding: 8px; color: black; text-align: center;">CLOSING SUMMARY</th>
                    </tr>
                    <tr style="background-color: #08396B; color: whitesmoke; font-weight: bold; font-size: 14px;">
                        <th style="padding: 5px; width: 150px;">Customer</th>
                        <th style="padding: 5px; width: 20px;">Category</th>
                        <th style="padding: 5px; width: 10px;">Code</th>
                        <th style="padding: 5px; width: 250px;">Item</th>
                        <th style="padding: 5px; width: 80px;">UOM (Kgs)</th>
                        <th style="padding: 5px; width: 40px;">Quantity</th>
                        <th style="padding: 5px; width: 40px;">Salesman</th>
                        <th style="padding: 5px; width: 40px;">ReceivedBy</th>
                        <th style="padding: 5px; width: 40px;">PaymentMode</th>
                        <th style="padding: 5px; width: 90px;">TotalAmount</th>
                        <th style="padding: 5px; width: 90px;">Paid Amount</th>
                        <th style="padding: 5px; width: 40px;">OutStanding</th>
                    </tr>
                </thead>
                <tbody>
    `);


        // Track the previous SaleOrderId to identify duplicates
        let previousSaleOrderId = null;

        // Add rows with conditional logic for duplicates
        data.forEach((rowData, index) => {
            const isDuplicate = rowData.SaleOrderId === previousSaleOrderId;

            printWindow.document.write('<tr>');
            printWindow.document.write(`<td style="border: 1px solid #ddd; font-size: 16px; text-align: center">${index + 1}</td>`);
            printWindow.document.write(`<td style="border: 1px solid #ddd; font-size: 16px;">${!isDuplicate ? rowData.CustomerName || '' : ''}</td>`);
            printWindow.document.write(`<td style="border: 1px solid #ddd; font-size: 16px;">${rowData.productCategory || ''}</td>`);
            printWindow.document.write(`<td style="border: 1px solid #ddd; font-size: 16px;">${rowData.itemCode || ''}</td>`);
            printWindow.document.write(`<td style="border: 1px solid #ddd; font-size: 16px;">${rowData.item || ''}</td>`);
            printWindow.document.write(`<td style="border: 1px solid #ddd; font-size: 16px;">${rowData.kilogram || ''}</td>`);
            printWindow.document.write(`<td style="border: 1px solid #ddd; font-size: 16px; text-align: center">${rowData.quantity || ''}</td>`);
            printWindow.document.write(`<td style="border: 1px solid #ddd; font-size: 16px;">${!isDuplicate ? rowData.paymentReceivedBy || '' : ''}</td>`);
            printWindow.document.write(`<td style="border: 1px solid #ddd; font-size: 16px;">${!isDuplicate ? rowData.paymentMode || '' : ''}</td>`);
            printWindow.document.write(`<td style="border: 1px solid #ddd; font-size: 16px; text-align: right">${!isDuplicate ? (rowData.totalAmount ? rowData.totalAmount.toFixed(2) : '') : ''}</td>`);
            printWindow.document.write(`<td style="border: 1px solid #ddd; font-size: 16px; text-align: right">${!isDuplicate ? (rowData.paidamount ? rowData.paidamount.toFixed(2) : '') : ''}</td>`);
            printWindow.document.write(`<td style="border: 1px solid #ddd; font-size: 16px; text-align: right">${!isDuplicate ? (rowData.outstanding ? rowData.outstanding.toFixed(2) : '') : ''}</td>`);
            printWindow.document.write('</tr>');

            // Update the previous SaleOrderId for the next iteration
            previousSaleOrderId = rowData.SaleOrderId;
        });

        printWindow.document.write('</tbody></table></body>');

        // Expense Summary Table
        printWindow.document.write(`
        <div style="width: 100%; overflow-y: auto; margin-top: 20px;">
            <table style="width: 100%; border-collapse: collapse; text-align: left;">
                <thead>
                    <tr style="background-color: #E4E0E1;">
                        <th colspan="6" style="font-weight: bold; padding: 8px; color: black; text-align: center;">EXPENSE SUMMARY</th>
                    </tr>
                    <tr style="background-color: #08396B; color: whitesmoke; font-weight: bold;">
                        <th style="padding: 5px; width: 20%;">Salesman Name</th>
                        <th style="padding: 5px; width: 10%;">Expense Date</th>
                        <th style="padding: 5px; width: 10%;">Expense Type</th>
                        <th style="padding: 5px; width: 40%;">Note</th>
                        <th style="padding: 5px; width: 10%;">Odometer</th>
                        <th style="padding: 5px; width: 10%; text-align: right;">Amount</th>
                    </tr>
                </thead>
                <tbody>
    `);

        // Loop through Expense Summary data
        if (Array.isArray(filteredData) && filteredData.length > 0) {
            filteredData.forEach(item => {
                printWindow.document.write(`
                <tr>
                    <td>${item.SalesmanName}</td>
                    <td>${item.ExpenseDate ? new Date(item.ExpenseDate).toLocaleDateString('en-GB') : ''}</td>
                    <td>${item.ExpenseType}</td>
                    <td>${item.Note}</td>
                    <td>${item.OdoMeter}</td>
                    <td style="text-align: right;">${item.Amount ? item.Amount.toFixed(2) : '0.00'}</td>
                </tr>
            `);
            });
        } else {
            printWindow.document.write(`
            <tr>
                <td colspan="6" style="text-align: center; color: gray;">No expenses recorded</td>
            </tr>
        `);
        }

        // End Expense summary table
        printWindow.document.write('</tbody></table></div>');
        printWindow.document.write('</body></html>');
        printWindow.document.close();
        printWindow.print();
    };



    const handleExportExcel = () => {
        const workbook = XLSX.utils.book_new();
        const excelData = [];

        // **Add Header Section for Common Details**
        if (data.length > 0) {
            const firstRow = data[0];
            excelData.push([
                'Route:', firstRow.routeName || '',
                'Order Taken by:', firstRow.orderTakenby || '',
                'Sales Executive:', firstRow.salesman || '',
                'Order Date:', firstRow.orderDate ? new Date(firstRow.orderDate).toLocaleDateString('en-GB') : '',
                'Trip Name:', firstRow.tripName || '',
                'Vehicle No.:', firstRow.VehicleNo || '',
                'Driver:', firstRow.DriverName || '',
                'Start Km:', firstRow.StartKm || '',
                'End Km:', firstRow.EndKm || '',
                'ReFueling Km:', firstRow.refuleingKm || '',
            ]);

            // Empty row for spacing between header and table
            excelData.push([]);
        }

        // **1. Closing Summary Section with Conditional Duplication Check**
        excelData.push(['Closing Summary']);

        // Adding column headers for Closing Summary
        excelData.push([
            'Sl. No', 'Customer', 'Category', 'Code', 'Item', 'UOM (Kgs)', 'Quantity',
            'Salesman', 'Received By', 'Payment Mode', 'Total Amount', 'Paid Amount', 'Outstanding'
        ]);

        let previousSaleOrderId = null;

        data.forEach((rowData, index) => {
            excelData.push([
                index + 1,
                rowData.SaleOrderId === previousSaleOrderId ? '' : rowData.CustomerName || '',
                rowData.productCategory || '',
                rowData.itemCode || '',
                rowData.item || '',
                rowData.kilogram || '',
                rowData.quantity || '',
                rowData.SaleOrderId === previousSaleOrderId ? '' : rowData.salesman || '',
                rowData.SaleOrderId === previousSaleOrderId ? '' : rowData.paymentReceivedBy || '',
                rowData.SaleOrderId === previousSaleOrderId ? '' : rowData.paymentMode || '',
                rowData.SaleOrderId === previousSaleOrderId ? '' : (rowData.totalAmount ? rowData.totalAmount.toFixed(2) : ''),
                rowData.SaleOrderId === previousSaleOrderId ? '' : (rowData.paidamount ? rowData.paidamount.toFixed(2) : ''),
                rowData.SaleOrderId === previousSaleOrderId ? '' : (rowData.outstanding ? rowData.outstanding.toFixed(2) : '')
            ]);

            previousSaleOrderId = rowData.SaleOrderId;
        });

        // **2. Add an Empty Row, then Start the Expense Summary Section**
        excelData.push([]);
        excelData.push(['Expense Summary']);

        // Adding column headers for Expense Summary
        excelData.push([
            'Salesman Name', 'Expense Date', 'Expense Type', 'Note', 'Odometer', 'Amount'
        ]);

        filteredData.forEach(item => {
            excelData.push([
                item.SalesmanName,
                item.ExpenseDate ? new Date(item.ExpenseDate).toLocaleDateString('en-GB') : '',
                item.ExpenseType,
                item.Note,
                item.OdoMeter,
                item.Amount ? item.Amount.toFixed(2) : '0.00'
            ]);
        });

        // **Convert excelData into a sheet (2D array) and add it to the workbook**
        const sheet = XLSX.utils.aoa_to_sheet(excelData);

        // Ensure cells exist before applying styles:
        const applyStyle = (cellRef, style) => {
            if (sheet[cellRef]) {
                sheet[cellRef].s = style;
            }
        };
        // Add custom styles for headers (both Closing Summary and Expense Summary headers)
        applyStyle('A1', {
            fill: { fgColor: { rgb: "FFFF00" } }, // Yellow background
            font: { bold: true, color: { rgb: "000000" } } // Bold text with black color
        });

        applyStyle('A2', {
            fill: { fgColor: { rgb: "FFFF00" } }, // Yellow background for column headers
            font: { bold: true, color: { rgb: "000000" } }
        });

        // Styling for Expense Summary header
        const expenseSummaryHeaderIndex = excelData.length - filteredData.length - 2; // The index of the Expense Summary header
        applyStyle(`A${expenseSummaryHeaderIndex}`, {
            fill: { fgColor: { rgb: "ADD8E6" } }, // Light blue background
            font: { bold: true, color: { rgb: "000000" } } // Bold text with black color
        });

        applyStyle(`A${expenseSummaryHeaderIndex + 1}`, {
            fill: { fgColor: { rgb: "ADD8E6" } }, // Light blue background for column headers
            font: { bold: true, color: { rgb: "000000" } }
        });

        // Append the sheet to the workbook
        XLSX.utils.book_append_sheet(workbook, sheet, "Route Closing  Summary");

        // Export the workbook
        XLSX.writeFile(workbook, "Route_Closing_Summary.xlsx");
    };


    const getRowColor = (balanceQty, weight) => {
        if (balanceQty <= weight / 2) {
            return { backgroundColor: '#FFD0D0' };
        }
        else if (balanceQty <= weight / 3) {
            return { backgroundColor: '#FFFFE0' };
        }
        else {
            return {}; // Default style
        }
    };
    const handleRefreshClick = () => {

        // setToDate(getCurrentDate());
        // fetchData();
        window.location.reload();
    };

    return (
        <div className="w-full  mx-auto" style={{ width: '97%', marginTop: '10px' }}>
            <h6
                className="uppercase tracking-wide text-black flex-grow linkcolor"
                style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif' }}> CLOSING SUMMARY DETAILED</h6>
            {loading && (
                <div style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    backgroundColor: 'rgba(0, 0, 0, 0.5)',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    zIndex: 9999
                }}>
                    <div>
                        <CircularProgress style={{ color: 'white' }} />
                        <span style={{ color: 'white', marginTop: '10px', display: 'block' }}>Loading...</span>
                    </div>
                </div>
            )}
            <div className="flex mb-2" style={{ marginTop: '-20px', marginLeft: '20%' }}>
                <h5 className="text-black" style={{ fontSize: '14px', flexGrow: 1 }}>
                    Route: <strong style={{ color: 'darkblue' }}>{route}</strong>
                </h5>
                <h5 className="text-black" style={{ fontSize: '14px', flexGrow: 1, marginLeft: '1%' }}>
                    Order Taken Date: <strong style={{ color: 'darkred' }}>{Corderdate && new Date(Corderdate).toLocaleDateString('en-GB')}</strong>
                </h5>
                <h5 className="text-black" style={{ fontSize: '14px', flexGrow: 1, marginLeft: '1%' }}>
                    Order Taken By: <strong style={{ color: 'darkmagenta' }}>{orderTakenby}</strong>
                </h5>
                <h5 className="text-black" style={{ fontSize: '14px', flexGrow: 1, marginLeft: '1%' }}>
                    Trip Name: <strong style={{ color: 'darkgreen' }}>{TripName}</strong>
                </h5>
            </div>
            <div className="flex mb-2" style={{ marginTop: '-10px', marginLeft: '20%' }}>
                <h5 className="text-black" style={{ fontSize: '14px', flexGrow: 1 }}>
                    Start OdoMeter: <strong style={{ color: 'darkblue' }}>{Startkm}</strong>
                </h5>
                <h5 className="text-black" style={{ fontSize: '14px', flexGrow: 1, marginLeft: '1%' }}>
                    End OdoMeter: <strong style={{ color: 'darkred' }}>{EndKm}</strong>
                </h5>
                <h5 className="text-black" style={{ fontSize: '14px', flexGrow: 1, marginLeft: '1%' }}>
                    Driver Name: <strong style={{ color: 'darkmagenta' }}>{DriverName}</strong>
                </h5>
                <h5 className="text-black" style={{ fontSize: '14px', flexGrow: 1, marginLeft: '1%' }}>
                    Vehicle No: <strong style={{ color: 'darkgreen' }}>{vehicleNo}</strong>
                </h5>
                <h5 className="text-black" style={{ fontSize: '14px', flexGrow: 1, marginLeft: '1%' }}>
                    ReFueling KM: <strong style={{ color: 'darkgreen' }}>{Refuleingkm}</strong>
                </h5>
            </div>

            <div className="flex justify-end">

                  <div className="w-1/4 mr-2" style={{ marginTop: '-10px', marginLeft: '2px' }}>
                    <Select
                        value={selectedTrip}
                        onChange={handleTripChange}
                        options={tripOptions}
                        placeholder="Select Trip"
                    >
                    </Select>
                </div>

                 <Button
                    style={{
                        backgroundColor: '#C9E9D2',
                        color: 'black',
                        height: '36px',
                        marginTop: '-10px',
                        marginRight: '5px'

                    }}
                    onClick={handleRefreshClick}
                    className="linkcolor"
                >
                    <span>Refresh</span>
                </Button>

                <Button
                    style={{
                        backgroundColor: '#F8E8EE',
                        color: 'black',
                        height: '36px',
                        marginTop: '-10px',
                        marginLeft: '5px'

                    }}
                    onClick={handleExportExcel}
                    className="linkcolor"
                >
                    <span>Excel</span>
                </Button>
                <Button
                    style={{
                        backgroundColor: '#E8F3D6',
                        color: 'black',
                        height: '36px',
                        marginTop: '-10px',
                        marginLeft: '5px'

                    }}
                    onClick={handlePrint}
                    className="linkcolor"
                >
                    <span>Print</span>
                </Button>
               

              
            </div>
            <div className='w-full mb-5 flex' style={{ overflowY: 'auto', Width: '2500px', marginTop: '5px' }}>
                <TableContainer component={Paper}>

                    <Table>

                        <TableHead sx={{ Width: '2500px' }}>
                            <TableRow style={{ backgroundColor: '##E4E0E1', textAlign: 'center' }}>
                                <TableCell
                                    colSpan={13}
                                    sx={{
                                        fontWeight: 'bolder',
                                        color: 'Black',
                                        textAlign: 'center',
                                        padding: '8px',
                                    }}
                                >
                                    <span> CLOSING SUMMARY</span>
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell sx={{ backgroundColor: '#08396B', borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '5px', color: 'whitesmoke', textAlign: 'left', width: '150px' }}>Customer</TableCell>
                                <TableCell sx={{ backgroundColor: '#08396B', borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '5px', color: 'whitesmoke', textAlign: 'left', width: '20px' }}>Category</TableCell>
                                <TableCell sx={{ backgroundColor: '#08396B', borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '5px', color: 'whitesmoke', textAlign: 'left', width: '10px' }}>Code</TableCell>
                                <TableCell sx={{ backgroundColor: '#08396B', borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '5px', color: 'whitesmoke', textAlign: 'left', width: '250px' }}>Item</TableCell>
                                <TableCell sx={{ backgroundColor: '#08396B', borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '5px', color: 'whitesmoke', textAlign: 'left', width: '80px' }}>UOM (Kgs)</TableCell>
                                <TableCell sx={{ backgroundColor: '#08396B', borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '5px', color: 'whitesmoke', textAlign: 'left', width: '40px' }}>Quantity</TableCell>
                                <TableCell sx={{ backgroundColor: '#08396B', borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '5px', color: 'whitesmoke', textAlign: 'left', width: '40px' }}>Salesman</TableCell>
                                <TableCell sx={{ backgroundColor: '#08396B', borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '5px', color: 'whitesmoke', textAlign: 'left', width: '40px' }}>ReceivedBy</TableCell>
                                <TableCell sx={{ backgroundColor: '#08396B', borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '5px', color: 'whitesmoke', textAlign: 'left', width: '40px' }}>PaymentMode</TableCell>
                                <TableCell sx={{ backgroundColor: '#08396B', borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '5px', color: 'whitesmoke', textAlign: 'right', width: '90px' }}>TotalAmount</TableCell>
                                <TableCell sx={{ backgroundColor: '#08396B', borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '5px', color: 'whitesmoke', textAlign: 'right', width: '90px' }}>Paid Amount</TableCell>
                                <TableCell sx={{ backgroundColor: '#08396B', borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '14px', padding: '5px', color: 'whitesmoke', textAlign: 'right', width: '40px' }}>OutStanding</TableCell>

                            </TableRow>
                        </TableHead>


                        <TableBody sx={{ backgroundColor: '##E4E0E1' }}>
                            {data.map((item, index) => {
                                // Check if the current SaleOrderId matches the previous row's SaleOrderId
                                const isDuplicate = index > 0 && item.SaleOrderId === data[index - 1].SaleOrderId;

                                return (

                                    <TableRow
                                        key={item.id}
                                        className={item.routeName === 'Total' ? 'highlighted-row' : ''}
                                        sx={{
                                            padding: '3px',
                                            height: '32px',
                                            backgroundColor: item.routeName === 'Total' ? 'teal' : 'transparent',
                                        }}
                                        Sale Summary
                                    >
                                        <TableCell sx={{ borderBottom: '1px solid #000000', borderRight: '1px solid #000000', color: 'black', fontWeight: 'bolder', padding: '3px', textAlign: 'left', fontSize: '13px', width: '150px' }}>
                                            {!isDuplicate ? item.CustomerName : ''}
                                        </TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid #000000', borderRight: '1px solid #000000', color: 'black', fontWeight: 'bolder', padding: '3px', textAlign: 'left', fontSize: '13px', width: '20px' }}>
                                            {item.productCategory}
                                        </TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid #000000', borderRight: '1px solid #000000', color: 'black', fontWeight: 'bolder', padding: '3px', textAlign: 'left', fontSize: '13px', width: '10px' }}>
                                            {item.itemCode}
                                        </TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid #000000', borderRight: '1px solid #000000', color: 'salmon', fontWeight: 'bolder', padding: '3px', textAlign: 'left', fontSize: '13px', width: '250px' }}>
                                            {item.item}
                                        </TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid #000000', borderRight: '1px solid #000000', color: 'Black', fontWeight: 'bolder', padding: '3px', textAlign: 'center', fontSize: '13px', width: '40px' }}>
                                            {item.kilogram}
                                        </TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid #000000', borderRight: '1px solid #000000', color: 'Black', fontWeight: 'bolder', padding: '3px', textAlign: 'center', fontSize: '13px', width: '40px' }}>
                                            {item.quantity}
                                        </TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid #000000', borderRight: '1px solid #000000', color: 'Black', fontWeight: 'bolder', padding: '3px', textAlign: 'center', fontSize: '13px', width: '40px' }}>
                                            {/* {item.salesman} */}
                                            {!isDuplicate ? item.salesman : ''}
                                        </TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid #000000', borderRight: '1px solid #000000', color: 'Black', fontWeight: 'bolder', padding: '3px', textAlign: 'center', fontSize: '13px', width: '40px' }}>
                                            {/* {item.paymentReceivedBy} */}
                                            {!isDuplicate ? item.paymentReceivedBy : ''}
                                        </TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid #000000', borderRight: '1px solid #000000', color: 'Black', fontWeight: 'bolder', padding: '3px', textAlign: 'left', fontSize: '13px', width: '40px' }}>
                                            {/* {item.paymentMode} */}
                                            {!isDuplicate ? item.paymentMode : ''}
                                        </TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid #000000', borderRight: '1px solid #000000', color: 'Black', fontWeight: 'bolder', padding: '3px', textAlign: 'right', fontSize: '13px', width: '40px' }}>
                                            {!isDuplicate ? (item.totalAmount != null ? item.totalAmount.toFixed(2) : '') : ''}
                                        </TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid #000000', borderRight: '1px solid #000000', color: 'Black', fontWeight: 'bolder', padding: '3px', textAlign: 'right', fontSize: '13px', width: '40px' }}>
                                            {/* {item.paidamount != null ? item.paidamount.toFixed(2) : ''} */}
                                            {!isDuplicate ? (item.paidamount != null ? item.paidamount.toFixed(2) : '') : ''}
                                        </TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid #000000', borderRight: '1px solid #000000', color: 'Black', fontWeight: 'bolder', padding: '3px', textAlign: 'right', fontSize: '13px', width: '40px' }}>
                                            {/* {item.outstanding != null ? item.outstanding.toFixed(2) : ''} */}
                                            {!isDuplicate ? (item.outstanding != null ? item.outstanding.toFixed(2) : '') : ''}
                                        </TableCell>
                                    </TableRow>
                                );
                            })}


                        </TableBody>

                    </Table>
                </TableContainer>

            </div>
            <div className='w-full mb-5 flex' style={{ overflowY: 'auto', Width: '2500px', marginTop: '-3%' }}>
                <TableContainer component={Paper}>
                    <Table>
                        <TableHead sx={{ backgroundColor: '#08396B', Width: '2500px' }}></TableHead>
                        <TableBody>
                            <TableRow>
                                <TableCell
                                    colSpan={13}
                                    sx={{
                                        fontWeight: 'bolder',
                                        backgroundColor: '',
                                        color: 'Black',
                                        textAlign: 'center',
                                        padding: '8px',
                                    }}
                                >
                                    EXPENSE SUMMARY
                                </TableCell>
                            </TableRow>


                            <TableRow >
                                {/* <TableCell sx={{ color: 'white', backgroundColor: '#08396B', fontWeight: 'bold', textAlign: 'left', padding: '4px', width: '2%' }}>Sl.No</TableCell> */}
                                <TableCell sx={{ color: 'white', backgroundColor: '#08396B', fontWeight: 'bold', textAlign: 'left', padding: '4px', width: '20%' }}>Salesman Name</TableCell>
                                <TableCell sx={{ color: 'white', backgroundColor: '#08396B', fontWeight: 'bold', textAlign: 'left', padding: '4px', width: '10%' }}>Expense Date</TableCell>
                                <TableCell sx={{ color: 'white', backgroundColor: '#08396B', fontWeight: 'bold', textAlign: 'left', padding: '4px', width: '10%' }}>Expense Type</TableCell>
                                <TableCell sx={{ color: 'white', backgroundColor: '#08396B', fontWeight: 'bold', textAlign: 'left', padding: '4px', width: '40%' }}>Note</TableCell>
                                <TableCell sx={{ color: 'white', backgroundColor: '#08396B', fontWeight: 'bold', textAlign: 'left', padding: '4px', width: '10%' }}>Odometer</TableCell>
                                <TableCell sx={{ color: 'white', backgroundColor: '#08396B', fontWeight: 'bold', textAlign: 'right', padding: '4px', width: '10%' }}>Amount</TableCell>
                            </TableRow>


                            {Array.isArray(filteredData) && filteredData.length > 0 ? (
                                filteredData.map((item, index) => (
                                    <TableRow key={item.Id}>
                                        {/* <TableCell sx={{ padding: '4px', color: 'Black', textAlign: 'left', borderBottom: '1px solid #000000', fontWeight: 'bolder', borderRight: '1px solid #000000' }}>
                                            {index + 1}
                                        </TableCell> */}
                                        <TableCell sx={{ padding: '4px', borderBottom: '1px solid #000000', borderRight: '1px solid #000000', fontWeight: 'bolder', color: 'Black', textAlign: 'left' }}>
                                            {item.SalesmanName}
                                        </TableCell>
                                        <TableCell sx={{ padding: '4px', borderBottom: '1px solid #000000', borderRight: '1px solid #000000', fontWeight: 'bolder', color: 'Black', textAlign: 'left' }}>
                                            {item.ExpenseDate ? new Date(item.ExpenseDate).toLocaleDateString('en-GB') : ''}
                                        </TableCell>
                                        <TableCell sx={{ padding: '4px', borderBottom: '1px solid #000000', borderRight: '1px solid #000000', fontWeight: 'bolder', color: 'Black', textAlign: 'left' }}>
                                            {item.ExpenseType}
                                        </TableCell>
                                        <TableCell sx={{ padding: '4px', borderBottom: '1px solid #000000', borderRight: '1px solid #000000', fontWeight: 'bolder', color: 'Black', textAlign: 'left' }}>
                                            {item.Note}
                                        </TableCell>
                                        <TableCell sx={{ padding: '4px', borderBottom: '1px solid #000000', borderRight: '1px solid #000000', fontWeight: 'bolder', color: 'Black', textAlign: 'left' }}>
                                            {item.OdoMeter}
                                        </TableCell>
                                        <TableCell sx={{ padding: '4px', borderBottom: '1px solid #000000', borderRight: '1px solid #000000', fontWeight: 'bolder', color: 'Black', textAlign: 'right' }}>
                                            {item.Amount ? item.Amount.toFixed(2) : '0.00'}
                                        </TableCell>
                                    </TableRow>
                                ))
                            ) : (
                                <TableRow>
                                    <TableCell colSpan={13} sx={{ textAlign: 'center', color: 'gray' }}>
                                        No expenses recorded
                                    </TableCell>
                                </TableRow>
                            )}

                        </TableBody>
                    </Table>
                </TableContainer>
            </div>

            <TableBody></TableBody>
        </div>
    );
}

export default ClosingSummary;

